<template>
  <VDialog
    v-if="value"
    :value="value"
    @input="$emit('input',$event)"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    :hide-overlay="$vuetify.breakpoint.smAndDown"
    max-width="848"
  >
    <VCard tile class="invitation-wrap">
      <DialogHeaderNew
        :title="$t('candidateInvitation')"
        @close="cancel"
      />
      <CandidateInvitation @cancel="cancel" :vacancy="vacancy" />
    </VCard>
  </VDialog>
</template>
<script>
import { invitationType } from '@/enums';
import CandidateInvitation from '@/components/CandidateInvitation/CandidateInvitation.vue';
import DialogHeaderNew from '../DialogHeaderNew.vue';

export default {
  name: 'VacancyCandidatesKanbanCreate',
  components: {
    CandidateInvitation,
    DialogHeaderNew,
  },
  props: {
    value: Boolean,
    vacancy: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      invitationType,
    };
  },
  methods: {
    cancel() {
      this.$emit('input', false);
    },
  },
};
</script>
<style lang="scss" scoped>
  .invitation-wrap {
    padding: 0 2.5rem 2.5rem;
    min-height: 39.875rem;
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .invitation-wrap {
      min-height: 100%;
    }
  }
</style>

<i18n locale="en" lang="yaml">
candidateInvitation: Candidate invitation
</i18n>

<i18n locale="ru" lang="yaml">
candidateInvitation: Приглашение кандидата
</i18n>
